// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_wavy_slotted_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_wavy_slotted_shade: ModuleSchema = {
  "id": "core_wavy_slotted_shade",
  "uniqueId": "B3D_5PDUA",
  "createdAt": "2026-10-08T08:19:34.502Z",
  "updatedAt": "2026-10-09T15:59:20.689Z",
  "label": "Slotted Shade",
  "description": "Reusable hollow shade with axial lobes, radial ribs, open slots and continuous end bridges.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_WSS01",
    "shade",
    "slotted"
  ],
  "sliders": [
    {
      "key": "maxDiameter",
      "label": "Maximum Diameter",
      "min": 30,
      "max": 160,
      "step": 1,
      "default": 67,
      "unit": "mm"
    },
    {
      "key": "troughDiameter",
      "label": "Trough Diameter",
      "min": 20,
      "max": 150,
      "step": 1,
      "default": 59,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shade Height",
      "min": 20,
      "max": 250,
      "step": 1,
      "default": 74,
      "unit": "mm"
    },
    {
      "key": "cavityOpeningDiameter",
      "label": "Cavity Opening Diameter",
      "min": 8,
      "max": 120,
      "step": 0.5,
      "default": 39.2,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Wall Thickness",
      "min": 0.8,
      "max": 5,
      "step": 0.1,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "shelfThickness",
      "label": "Seat Shelf Thickness",
      "min": 0.8,
      "max": 8,
      "step": 0.1,
      "default": 1.6,
      "unit": "mm"
    },
    {
      "key": "waveCount",
      "label": "Axial Lobes",
      "min": 1,
      "max": 10,
      "step": 1,
      "default": 3
    },
    {
      "key": "ribCount",
      "label": "Rib Count (0 disables ribs and slots)",
      "min": 0,
      "max": 120,
      "step": 2,
      "default": 36
    },
    {
      "key": "ribDepth",
      "label": "Rib Relief",
      "min": 0,
      "max": 5,
      "step": 0.1,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "slotWidth",
      "label": "Through-slot Width",
      "min": 0.2,
      "max": 4,
      "step": 0.1,
      "default": 0.9,
      "unit": "mm"
    },
    {
      "key": "endBridgeHeight",
      "label": "Continuous End Bridge Height",
      "min": 0.6,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    },
    {
      "key": "waistBandHeight",
      "label": "Intermediate Waist Band Height",
      "min": 0,
      "max": 6,
      "step": 0.2,
      "default": 2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [],
  "objects": [],
  "exportGroups": []
};
